export default function mergeClasses(...classes) {
  return classes.filter(Boolean).join(' ');
}